import { FormattedMessage } from "react-intl";

const translate = (id) => {
  return <FormattedMessage id={id} />;
};

export default translate;
